<style>

.bg{
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-image: url("/i/signup-bg-wizard.jpg");
  background-size: cover;
  color: black;
  padding: 20px;
  overflow-y: scroll;
}

.margin{
  margin-top: 50px;
}

.small{
  color: white;
}

.date{
  display: grid;
  grid-template-columns: auto;
  color: white;
  text-align: center;
  justify-items: center;
}
.month{
  grid-column: 1;
  padding: 10px 10px;
  border-bottom: 2px white solid;
  color: white;
  background-color: rgba(255,255,255,0.2);
}
.day{
  grid-column: 2;
  padding: 10px 10px;
  border-bottom: 2px white solid;
  color: white;
  background-color: rgba(255,255,255,0.2);
}
.year{
  grid-column: 3;
  padding: 10px 10px;
  border-bottom: 2px white solid;
  color: white;
  background-color: rgba(255,255,255,0.2);
}

</style>

<div class="bg">
  <div class="title-signup">When's your birthday?</div>
  
  <div class="margin">
    <div class="date">
      <div class="month">
        <MonthInput bind:month="{month}"></MonthInput>
      </div>
      <div class="day">
        <DayInput month="{month}"></DayInput>
      </div>
      <div class="year">
        <YearInput></YearInput>
      </div>
    </div>
  </div>
  
  <div class="margin small">You must be 18+ to sign up.</div>
  
  <div class="has-buttons"></div>
  
</div>

<div class="next">
  <button on:click="{next}">Next</button>
</div>

<script>

import {push, pop, replace, location, link} from 'svelte-spa-router';

import MonthInput from "../../../../components/MonthInput.svelte";
import DayInput from "../../../../components/DayInput.svelte";
import YearInput from "../../../../components/YearInput.svelte";


let month = -1;

function next() {
  push("/signup/profile/personal/gender");
}


</script>